import cn from 'clsx';
import { type CreditCardNetwork } from '@wix/cashier-common/dist/src/enums/payments/CreditCardNetwork';
import React, { type FC, memo, type PropsWithChildren } from 'react';
import { DH } from '../../../../utils/DataHook';
import { getCardNetworkIconURL } from '../utils';
import s from './styles.scss';

export const Container: FC<PropsWithChildren<{}>> = memo((props) => (
  <div className={s.cardNumberField} data-hook={DH.Field.Container.Number}>
    {props.children}
  </div>
));
Container.displayName = 'Container';

export const CardNetwork: FC<{
  cardNetwork: CreditCardNetwork;
  forceRightPosition: boolean;
}> = memo((props) => (
  <span
    className={cn({
      [s.cardNetworkIcon]: true,
      [s.positionRight]: props.forceRightPosition,
    })}
  >
    <img data-hook={DH.Field.CardNetworkIcon} src={getCardNetworkIconURL(props.cardNetwork)} alt="Card Type" />
  </span>
));
CardNetwork.displayName = 'CardNetwork';

export const CardNetworkRedesigned: FC<{
  cardNetwork: CreditCardNetwork;
}> = memo((props) => (
  <img
    className={s.image}
    data-hook={DH.Field.CardNetworkIcon}
    src={getCardNetworkIconURL(props.cardNetwork)}
    alt={props.cardNetwork}
    aria-label={props.cardNetwork}
  />
));
CardNetworkRedesigned.displayName = 'CardNetworkRedesigned';

export const CardNetworksListRedesigned: FC<{
  cardNetworks: CreditCardNetwork[];
}> = (props) => (
  <div className={s.cardNetworksListRedesigned} data-hook={DH.Field.CardNetworkIconList}>
    {props.cardNetworks?.map((cardNetwork) => (
      <CardNetworkRedesigned key={cardNetwork} cardNetwork={cardNetwork} />
    ))}
  </div>
);
